import invert from 'lodash/invert';
import {
  BACKEND_EVENT_NAME,
  SYSTEM_EVENTS_METADATA,
} from 'modules/journey/components/RuleBuilder/constants';
import {
  CustomEventHoldRule,
  HoldNodeData,
  SystemEventHoldRule,
  UserPropertyHoldRule,
} from 'modules/workflows/types';
import { TextSegmentConfig } from 'ui/workflows/flowchart/types';

/** Gets user friendly name for system events */
export const getLabelFromSystemEventName = (eventName: string) => {
  const eventNameWorkflowTrigger = invert(BACKEND_EVENT_NAME)[eventName];
  const { label } = SYSTEM_EVENTS_METADATA[eventNameWorkflowTrigger] || {};
  return label;
};

const getGenericTextSegment = () => {
  return [[{ text: 'Event occurs' }]];
};

/** Gets the text segments for hold tile description if event rule */
const getCustomEventTextSegment = (triggerRule: CustomEventHoldRule | SystemEventHoldRule) => {
  const { eventName } = triggerRule;
  return [
    [{ text: 'Event occurs:' }],
    [{ text: getLabelFromSystemEventName(eventName) || eventName }],
  ];
};

/** Gets the text segments for hold tile description if user property rule */
const getUserPropertyUpdateTextSegment = (triggerRule: UserPropertyHoldRule) => {
  return [[{ text: 'User property changes:' }], [{ text: triggerRule.field }]];
};

export const getTextSegments = (nodeData: HoldNodeData): { nodeDescBottom: TextSegmentConfig } => {
  const {
    triggerRule = {
      triggerRuleType: '',
    },
  } = nodeData;

  return {
    nodeDescBottom: {
      isTruncated: true,
      segments: [
        ...(!!triggerRule && 'eventName' in triggerRule && triggerRule.eventName
          ? getCustomEventTextSegment(triggerRule)
          : []),
        ...(!!triggerRule && 'field' in triggerRule && triggerRule.field
          ? getUserPropertyUpdateTextSegment(triggerRule as UserPropertyHoldRule)
          : []),
        // @ts-ignore
        ...(!!triggerRule && !triggerRule.field && !triggerRule.eventName
          ? getGenericTextSegment()
          : []),
      ],
    },
  };
};
